import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable, Injector } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveEnd, Router } from '@angular/router';
import { ApplicationInsights, DistributedTracingModes } from '@microsoft/applicationinsights-web';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { XWareLogService } from './xware-log.service';
@Injectable({
  providedIn: 'root',
})
export class AiMonitoringService {
  private routerSubscription: Subscription;
  instrumentationKey: string;
  Version: string;
  appInsights: ApplicationInsights;
  tenantName: string;
  refUri: string;
  constructor(
    private router: Router,
    @Inject('instrumentationKey') myinstrumentationKey: string,
    @Inject('appVersion') myVersion: string,
    private injector: Injector,
    private xWareLogService: XWareLogService
  ) {
    this.tenantName = sessionStorage.getItem('TenantName');

    this.instrumentationKey = myinstrumentationKey;
    this.Version = myVersion;
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: this.instrumentationKey,
        enableCorsCorrelation: true,
        distributedTracingMode: DistributedTracingModes.W3C,
        onunloadDisableBeacon: true,
      },
    });

    this.appInsights.loadAppInsights();

    this.appInsights.context.application.ver = this.Version;

    this.xWareLogService.log(
      'App insights loaded:' +
        this.Version +
        ':traceid=' +
        this.appInsights.context.telemetryTrace.traceID +
        ':parentid=' +
        this.appInsights.context.telemetryTrace.parentID
    );

    var filteringFunction = envelope => {
      if (!envelope.baseData) {
        this.xwareLogDebug('null basedata');
        return true;
      } else {
        if (!envelope.baseData.target) {
          this.xwareLogDebug('null target');
        } else {
          if (envelope.baseData.target.includes('https://graph.microsoft.com/v1.0/me/photo')) {
            this.xwareLogDebug('dropping request');
            return false;
          }
        }
      }
      var telemetryItem = envelope.baseData;

      // To set custom properties:
      telemetryItem.properties = telemetryItem.properties || {};
      telemetryItem.properties['tenantname'] = sessionStorage.getItem('tenantName');
      this.xwareLogDebug('appinsigts:telemetryItem=' + JSON.stringify(telemetryItem));
      return true;
    };

    this.appInsights.addTelemetryInitializer(filteringFunction);

    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof ResolveEnd))
      .subscribe((event: ResolveEnd) => {
        const activatedComponent = this.getActivatedComponent(event.state.root);
        if (activatedComponent) {
          this.refUri = event.state.url;
          //this.logPageView(`${this.getRouteTemplate(event.state.root)}`, event.urlAfterRedirects);
          this.logPageView(event.urlAfterRedirects, event.urlAfterRedirects);
        }
      });
  }

  setUserId(userId: string) {
    this.appInsights.setAuthenticatedUserContext(userId);
  }

  clearUserId() {
    this.appInsights.clearAuthenticatedUserContext();
  }

  private logPageView(name?: string, uri?: string) {
    //const properties = { tenantName: this.tenantName, refUri: this.refUri };
    this.appInsights.trackPageView();
  }

  private logError(error?: HttpErrorResponse) {
    this.appInsights.trackException(error);
  }

  private logErrorStack(error?: string) {
    this.appInsights.trackException({ exception: new Error(error) });
  }

  private trackTrace(message?: string) {
    this.appInsights.trackTrace({ message });
  }

  private logEvent(name?: string) {
    this.appInsights.trackEvent({ name });
  }

  private getActivatedComponent(snapshot: ActivatedRouteSnapshot): any {
    if (snapshot.firstChild) {
      return this.getActivatedComponent(snapshot.firstChild);
    }

    return snapshot.component;
  }

  private getRouteTemplate(snapshot: ActivatedRouteSnapshot): string {
    let path = '';
    if (snapshot.routeConfig) {
      path += snapshot.routeConfig.path;
    }

    if (snapshot.firstChild) {
      return path + this.getRouteTemplate(snapshot.firstChild);
    }

    return path;
  }

  /// ..................public..functions..................///
  public xwareLogDebug(msg: string) {
    // this.trackTrace('LogDebug  => ' + this.tenantName + ' => ' + msg);
    this.xWareLogService.log('xw-debug:' + this.tenantName + msg, 'ai');
  }

  public xwareLogInfo(msg: string) {
    this.trackTrace(this.tenantName + ' => ' + msg);
    this.xWareLogService.log('xw-info:' + this.tenantName + msg, 'ai');
  }

  public xwareLogWarn(msg: string) {
    this.trackTrace(this.tenantName + ' => ' + msg);
  }

  public xwaretrackTrace(msg: string) {
    this.trackTrace(this.tenantName + ' => ' + msg);
    this.xWareLogService.log('xw-trackTrace:' + this.tenantName + msg, 'ai');
  }
  public xwareLogError(error: HttpErrorResponse) {
    this.logError(error);
  }

  public xwareLogErrorStack(error: string) {
    this.logErrorStack(this.tenantName + ' => ' + error);
  }

  public xwareLogEvent(event: string) {
    this.xWareLogService.log('xw-event:' + this.tenantName + ' => ' + event, 'ai');
    this.logEvent(event);
  }

  public xwareLogPageView(model: string) {
    this.xWareLogService.log('xw-PageView: ' + this.tenantName + ' => ' + model, 'ai');
    this.logPageView(model);
  }
}
